(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7ba9536"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('promo-grid-banner')) {
  customElements.define('promo-grid-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.alignGrid !== 'true') return;
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.queueSync = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.syncGrid();
        });
      };
      this.resizeObserver = new ResizeObserver(this.queueSync);
      this.resizeObserver.observe(this);
      // Filters and sorting can replace the product-grid element.
      this.mutationObserver = new MutationObserver(this.queueSync);
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', this.queueSync);
      this.desktop.addEventListener('change', this.queueSync);
      this.queueSync();
    }

    syncGrid() {
      if (!this.isConnected) return;
      const grid = document.getElementById('product-grid');
      if (grid !== this.grid) {
        if (this.grid) this.resizeObserver.unobserve(this.grid);
        this.grid = grid;
        if (grid) this.resizeObserver.observe(grid);
      }
      if (!this.desktop.matches || !grid || !grid.getClientRects().length) {
        this.clearGridSize();
        return;
      }
      const gridBox = grid.getBoundingClientRect();
      const bannerBox = this.getBoundingClientRect();
      if (gridBox.width <= 0 || bannerBox.width <= 0) {
        this.clearGridSize();
        return;
      }
      // The wrapper stays in normal flow; only its visible inner banner aligns.
      this.style.setProperty('--promo-grid-width', `${gridBox.width}px`);
      this.style.setProperty('--promo-grid-offset', `${gridBox.left - bannerBox.left}px`);
    }

    clearGridSize() {
      this.style.removeProperty('--promo-grid-width');
      this.style.removeProperty('--promo-grid-offset');
    }

    disconnectedCallback() {
      if (!this.queueSync) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.resizeObserver.disconnect();
      this.mutationObserver.disconnect();
      window.removeEventListener('resize', this.queueSync);
      this.desktop.removeEventListener('change', this.queueSync);
      this.grid = null;
      this.clearGridSize();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_82f56fb"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('promo-grid-banner')) {
  customElements.define('promo-grid-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.alignGrid !== 'true') return;
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.queueSync = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.syncGrid();
        });
      };
      this.resizeObserver = new ResizeObserver(this.queueSync);
      this.resizeObserver.observe(this);
      // Filters and sorting can replace the product-grid element.
      this.mutationObserver = new MutationObserver(this.queueSync);
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', this.queueSync);
      this.desktop.addEventListener('change', this.queueSync);
      this.queueSync();
    }

    syncGrid() {
      if (!this.isConnected) return;
      const grid = document.getElementById('product-grid');
      if (grid !== this.grid) {
        if (this.grid) this.resizeObserver.unobserve(this.grid);
        this.grid = grid;
        if (grid) this.resizeObserver.observe(grid);
      }
      if (!this.desktop.matches || !grid || !grid.getClientRects().length) {
        this.clearGridSize();
        return;
      }
      const gridBox = grid.getBoundingClientRect();
      const bannerBox = this.getBoundingClientRect();
      if (gridBox.width <= 0 || bannerBox.width <= 0) {
        this.clearGridSize();
        return;
      }
      // The wrapper stays in normal flow; only its visible inner banner aligns.
      this.style.setProperty('--promo-grid-width', `${gridBox.width}px`);
      this.style.setProperty('--promo-grid-offset', `${gridBox.left - bannerBox.left}px`);
    }

    clearGridSize() {
      this.style.removeProperty('--promo-grid-width');
      this.style.removeProperty('--promo-grid-offset');
    }

    disconnectedCallback() {
      if (!this.queueSync) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.resizeObserver.disconnect();
      this.mutationObserver.disconnect();
      window.removeEventListener('resize', this.queueSync);
      this.desktop.removeEventListener('change', this.queueSync);
      this.grid = null;
      this.clearGridSize();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
